export default function GoogleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>Google Icon</title>
      <g clipPath="url(#clip0_161_1383)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.825 20.4546C39.825 19.0364 39.6977 17.6727 39.4614 16.3636H20.625V24.1H31.3886C30.925 26.6 29.5159 28.7182 27.3977 30.1364V35.1546H33.8614C37.6432 31.6727 39.825 26.5455 39.825 20.4546Z"
          fill="#4285F4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6247 40C26.0247 40 30.552 38.2091 33.8611 35.1545L27.3974 30.1364C25.6065 31.3364 23.3156 32.0454 20.6247 32.0454C15.4156 32.0454 11.0065 28.5273 9.43377 23.8H2.75195V28.9818C6.04286 35.5182 12.8065 40 20.6247 40Z"
          fill="#34A853"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.43409 23.8C9.03409 22.6 8.80682 21.3182 8.80682 20C8.80682 18.6818 9.03409 17.4 9.43409 16.2V11.0182H2.75227C1.39773 13.7182 0.625 16.7727 0.625 20C0.625 23.2273 1.39773 26.2818 2.75227 28.9818L9.43409 23.8Z"
          fill="#FBBC05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6247 7.95455C23.5611 7.95455 26.1974 8.96364 28.2701 10.9455L34.0065 5.20909C30.5429 1.98182 26.0156 0 20.6247 0C12.8065 0 6.04286 4.48182 2.75195 11.0182L9.43377 16.2C11.0065 11.4727 15.4156 7.95455 20.6247 7.95455Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_161_1383">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
